// extracted by mini-css-extract-plugin
module.exports = {"socketClientSwitch":"styles_socketClientSwitch__3ID3i","buttons":"styles_buttons__3SuHS","switchDevice":"styles_switchDevice__3HM7U","onoff":"styles_onoff__2D1v7"};